import { render, staticRenderFns } from "./GeneralConfiguration.vue?vue&type=template&id=af818e8c&scoped=true"
import script from "./GeneralConfiguration.vue?vue&type=script&lang=js"
export * from "./GeneralConfiguration.vue?vue&type=script&lang=js"
import style0 from "./GeneralConfiguration.vue?vue&type=style&index=0&id=af818e8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af818e8c",
  null
  
)

export default component.exports